import { render, staticRenderFns } from "./GameBoard.vue?vue&type=template&id=659bfa36&scoped=true&"
import script from "./GameBoard.vue?vue&type=script&lang=ts&"
export * from "./GameBoard.vue?vue&type=script&lang=ts&"
import style0 from "./GameBoard.vue?vue&type=style&index=0&id=659bfa36&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659bfa36",
  null
  
)

export default component.exports